<template>
  <div>
    <div class="item-head">
      <span class="badge badge-pill badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill badge-light">{{ item.id }}</span>
      <label class="mini-check"><input :id="`secure-${item.id}`" type="checkbox" v-model="item.security"> محافظت</label>
      <input type="text" class="form-control slug" v-model="item['slug']" placeholder="slug">
      <input type="text" class="form-control title-input" v-model="item.title" placeholder="عنوان">
      <b-icon class="bg-primary p-1 rounded-pill text-white" icon="plus" @click="addOption()"/>
      <b-icon class="bg-danger p-1 rounded-pill text-white" icon="trash" @click="deleteQuestion()"/>
    </div>
    <div class="opt-list">
      <div class="opt-row" v-for="(option,index) in item.options" :key="index" @click="setActiveValue(index)">
        <input :checked="option.value == 1" class="form-check-input" type="radio" :name="generateHashComputed" :value="option.value">
        <input type="text" class="form-control form-control-sm" v-model="option.label">
        <input type="number" class="form-control form-control-sm opt-price" v-model="option.price" placeholder="قیمت" min="0" @click.stop>
        <label class="opt-img">
          <img v-if="option.image" :src="option.image" alt="">
          <span v-else>عکس</span>
          <input @change="uploadImage($event,index)" type="file">
        </label>
        <b-icon class="text-danger" icon="x" @click.stop="deletedOption(index)"/>
      </div>
    </div>
  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default {
  name: "RadioBoxInput",
  props: {item: {}},
  computed: {
    generateHashComputed() {
      return generateHash()
    }
  },
  methods: {
    setActiveValue(index) {
      this.item.options.forEach(item => {
        item['value'] = 0
      })
      this.item.options[index]['value'] = 1
    },
    addOption() {
      let countOptions = this.item.options.length
      this.item.options.push({
        "id": (countOptions + 1),
        "label": "ایتم",
        "value": 0,
        "image": "",
        "price": ""
      })
      this.$forceUpdate()
    },
    deletedOption(index) {
      if (confirm('آیا از حذف ایتم اطمینان دارید؟')) {
        this.item.options.splice(index, 1)
        this.$forceUpdate()
      }
    },
    deleteQuestion() {
      this.$emit('removeQuestion')
    },
    async checkFormImageDirectory() {
      let req = await this.$store.dispatch('FileManager/setDirectories')
      let folders = req.data.data
      if (folders.indexOf('form-images') > -1) {
        return true
      }
      return false
    },
    async createFolder() {
      let checker = await this.checkFormImageDirectory()
      if (checker == false) {
        let form = {name: 'form-images'}
        await this.$store.dispatch('FileManager/createDirectory', form)
      }
      return true
    },
    async uploadImage(event, optionIndex) {
      await this.createFolder()
      const file = event.target.files[0];
      let form = {
        uploadDirectory: 'form-images',
        selectedFiles: [file],
      }
      let req = await this.$store.dispatch('FileManager/uploadFiles', form)
      this.item.options[optionIndex]['image'] = req.data.data[0]['file']
      this.$forceUpdate()
    },
  },
  beforeMount() {
    this.item.options.forEach((item, index) => {
      if (Object.keys(item).indexOf('image') == -1) {
        this.item.options[index]['image'] = ""
      }
    })
  }
}
</script>

<style scoped>
.item-head,
.opt-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.item-head .form-control:not(.title-input):not(.slug) {
  flex: 1 1 160px;
}
.slug {
  flex: 0 1 110px !important;
}
.opt-row {
  margin-top: 4px;
}
.opt-row .form-control {
  flex: 1 1 140px;
}
.mini-check {
  font-size: 12px;
  margin: 0;
}
.opt-img {
  width: 36px;
  height: 28px;
  border: 1px dashed #ddd;
  border-radius: 6px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin: 0;
  cursor: pointer;
  position: relative;
}
.opt-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.opt-img input {
  display: none;
}
</style>
